import { render, staticRenderFns } from "./InactiveAccountsTab.vue?vue&type=template&id=40da33a4"
import script from "./InactiveAccountsTab.vue?vue&type=script&lang=js"
export * from "./InactiveAccountsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports